import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { chCreateMedicationMutation } from "@/modules/patients/detail/medication/ch/services/__generated__/chCreateMedicationMutation.graphql"

const mutation = graphql`
  mutation chCreateMedicationMutation($input: Ch_addMedicationInput!, $connections: [ID!]!) {
    ch_addMedication(input: $input) {
      ch_Medication @appendNode(connections: $connections, edgeTypeName: "Ch_medicationsEdge") {
        id
        ...chMedicationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateMedicationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<chCreateMedicationMutation>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<chCreateMedicationMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateMedicationMutation }
